import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Polygon, OverlayView } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
import { setVersionEditPathsOfPolygon } from 'store/requests/zone';
import { getZoneOptions } from 'helpers/utils';

const ViewSelectedVersionZoneForEdit = (props) => {
  const { onLoad, onUnmount, polygonRef } = props;

  const zoneState = useSelector((state) => state.zone.geoRadarZone) ?? null;
  const [contextMenuLatLng, setContextMenuLatLng] = useState(null);
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({
    top: 0,
    left: 0,
  });

  const contextMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        contextMenuRef.current &&
        !contextMenuRef.current.contains(event.target)
      ) {
        setShowContextMenu(false);
      }
    };

    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const onVersionEdit = useCallback(() => {
    if (polygonRef.current) {
      const nextPath = polygonRef.current
        .getPath()
        .getArray()
        .map((latLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
      setVersionEditPathsOfPolygon(nextPath);
    }
  }, [setVersionEditPathsOfPolygon]);

  const onRightClick = useCallback(
    (e) => {
      if (polygonRef.current) {
        const path = polygonRef.current.getPath();
        const clickedPointIndex = path.getArray().indexOf(e.latLng);
        if (clickedPointIndex !== -1) {
          setContextMenuLatLng(e.latLng);
          setContextMenuPosition({ top: e?.pixel?.y, left: e?.pixel?.x });
          setShowContextMenu(true);
        }
      }
    },
    [polygonRef],
  );

  const onDeleteClick = useCallback(() => {
    if (polygonRef.current && contextMenuLatLng) {
      const path = polygonRef.current.getPath();

      let clickedPointIndex = -1;
      path.forEach((latLng, index) => {
        if (
          latLng.lat() === contextMenuLatLng.lat() &&
          latLng.lng() === contextMenuLatLng.lng()
        ) {
          clickedPointIndex = index;
        }
      });

      if (clickedPointIndex !== -1) {
        if (clickedPointIndex === path.length - 1) {
          const firstPoint = path.getAt(0);
          const lastPoint = path.getAt(path.length - 1);

          if (
            firstPoint.lat() === lastPoint.lat() &&
            firstPoint.lng() === lastPoint.lng()
          ) {
            path.removeAt(clickedPointIndex);
            path.removeAt(0);
          }
        } else {
          path.removeAt(clickedPointIndex);
        }
        onVersionEdit();
      }
    }
    setContextMenuLatLng(null);
    setShowContextMenu(false);
  }, [polygonRef, contextMenuLatLng, onVersionEdit]);

  const polygonOptions = getZoneOptions({
    fillColor: zoneState?.zoneColor?.color,
    fillOpacity: zoneState?.zoneOpacity,
  });

  return (
    <>
      {zoneState?.selectedVersionZoneItem?.zonePolygonJson && (
        <Polygon
          options={polygonOptions}
          path={zoneState?.selectedVersionZoneItem?.zonePolygonJson}
          onMouseUp={onVersionEdit}
          onDragEnd={onVersionEdit}
          onRightClick={onRightClick}
          onLoad={onLoad}
          onUnmount={onUnmount}
        />
      )}
      {showContextMenu && contextMenuLatLng && (
        <OverlayView
          position={contextMenuLatLng}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
          <div
            ref={contextMenuRef}
            style={{
              position: 'absolute',
              top: `${contextMenuPosition.top}px`,
              left: `${contextMenuPosition.left}px`,
              background: 'white',
              border: '1px solid black',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <div onClick={onDeleteClick}>Delete</div>
          </div>
        </OverlayView>
      )}
    </>
  );
};

export default ViewSelectedVersionZoneForEdit;
